import type {Shareholder} from "@/store/api/shareholderApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface ShareholderFormData {
    complete: boolean;
    data: Shareholder | null;
}
interface ShareholderState {
    shareholderFormData: ShareholderFormData[];
    shareholders: Shareholder[] | null;
}

const initialState: ShareholderState = {
    shareholders: null,
    shareholderFormData: [
        {complete: false, data: null}
    ]
}

const shareholderSlice = createSlice({
    name: "shareholder",
    initialState,
    reducers: {
        addShareholder: (state) => {
            state.shareholderFormData.push({complete:false, data: null});
        },
        deleteShareholder: (state, action) => {
            state.shareholderFormData.splice(action.payload, 1)
        },
        saveShareholder: (state, action) => {
            const index = action.payload.index;
            const data = action.payload.data;
            state.shareholderFormData[index] = {complete: true, data: data};
        },
        updateShareholder: (state, action) => {
            const index = action.payload;
            if (state.shareholderFormData[index]){
                state.shareholderFormData[index].complete = false;
            }
        },
        setShareholders: (state, action: PayloadAction<Shareholder[]>)=> {
            state.shareholders = action.payload;
        },
    }
})

export const { setShareholders, addShareholder, deleteShareholder, saveShareholder, updateShareholder } = shareholderSlice.actions;
export default shareholderSlice.reducer;